// extracted by mini-css-extract-plugin
export default {"desktop":"desktop--opY0i","col":"col--25F0M","item-wrapper":"item-wrapper--NGDex","itemWrapper":"item-wrapper--NGDex"};